import React from 'react';
import { X } from 'lucide-react';
import { useSolutionStore } from '../../stores/solutionStore';

const SolutionFilters = () => {
  const { filters, categories, setFilters, clearFilters } = useSolutionStore();

  const handleFilterChange = (key, value) => {
    setFilters({ [key]: value });
  };

  const hasActiveFilters = Object.values(filters).some(value => value !== '');

  return (
    <div className="p-4 bg-gray-50">
      {/* Clear Filters */}
      {hasActiveFilters && (
        <div className="flex items-center justify-between mb-4">
          <span className="text-sm font-medium text-gray-700">Active Filters</span>
          <button
            onClick={clearFilters}
            className="flex items-center text-sm text-sigma-600 hover:text-sigma-700"
          >
            <X className="w-3 h-3 mr-1" />
            Clear All
          </button>
        </div>
      )}

      <div className="space-y-4">
        {/* Subject Filter */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Subject
          </label>
          <select
            value={filters.subject}
            onChange={(e) => handleFilterChange('subject', e.target.value)}
            className="w-full px-3 py-2 text-sm border border-gray-300 rounded-lg focus:ring-2 focus:ring-sigma-500 focus:border-sigma-500"
          >
            <option value="">All Subjects</option>
            {categories.subjects?.map((subject) => (
              <option key={subject.value} value={subject.value}>
                {subject.label}
              </option>
            ))}
          </select>
        </div>

        {/* Grade Level Filter */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Grade Level
          </label>
          <select
            value={filters.gradeLevel}
            onChange={(e) => handleFilterChange('gradeLevel', e.target.value)}
            className="w-full px-3 py-2 text-sm border border-gray-300 rounded-lg focus:ring-2 focus:ring-sigma-500 focus:border-sigma-500"
          >
            <option value="">All Grades</option>
            {categories.gradeLevels?.map((grade) => (
              <option key={grade.value} value={grade.value}>
                {grade.label}
              </option>
            ))}
          </select>
        </div>

        {/* Topic Filter */}
        {filters.subject && categories.topics?.[filters.subject] && (
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Topic
            </label>
            <select
              value={filters.topic}
              onChange={(e) => handleFilterChange('topic', e.target.value)}
              className="w-full px-3 py-2 text-sm border border-gray-300 rounded-lg focus:ring-2 focus:ring-sigma-500 focus:border-sigma-500"
            >
              <option value="">All Topics</option>
              {categories.topics[filters.subject]?.map((topic) => (
                <option key={topic.value} value={topic.value}>
                  {topic.label}
                </option>
              ))}
            </select>
          </div>
        )}

        {/* Difficulty Filter */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Difficulty
          </label>
          <select
            value={filters.difficulty}
            onChange={(e) => handleFilterChange('difficulty', e.target.value)}
            className="w-full px-3 py-2 text-sm border border-gray-300 rounded-lg focus:ring-2 focus:ring-sigma-500 focus:border-sigma-500"
          >
            <option value="">All Difficulties</option>
            {categories.difficulties?.map((difficulty) => (
              <option key={difficulty.value} value={difficulty.value}>
                {difficulty.label}
              </option>
            ))}
          </select>
        </div>

        {/* Type Filter */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Type
          </label>
          <select
            value={filters.type}
            onChange={(e) => handleFilterChange('type', e.target.value)}
            className="w-full px-3 py-2 text-sm border border-gray-300 rounded-lg focus:ring-2 focus:ring-sigma-500 focus:border-sigma-500"
          >
            <option value="">All Types</option>
            {categories.types?.map((type) => (
              <option key={type.value} value={type.value}>
                {type.label}
              </option>
            ))}
          </select>
        </div>
      </div>

      {/* Active Filter Tags */}
      {hasActiveFilters && (
        <div className="mt-4 pt-4 border-t border-gray-200">
          <div className="flex flex-wrap gap-1">
            {Object.entries(filters).map(([key, value]) => {
              if (!value) return null;
              
              return (
                <span
                  key={key}
                  className="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-sigma-100 text-sigma-800"
                >
                  {value}
                  <button
                    onClick={() => handleFilterChange(key, '')}
                    className="ml-1 text-sigma-600 hover:text-sigma-800"
                  >
                    <X className="w-3 h-3" />
                  </button>
                </span>
              );
            })}
          </div>
        </div>
      )}
    </div>
  );
};

export default SolutionFilters;